export default searchParam => new URLSearchParams(window.location.search).get(searchParam);
